import { MapfreButtonComponent } from '../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent],
  selector: 'app-autopay-terms-conditions',
  templateUrl: './autopay-terms-conditions.component.html',
  styleUrls: ['./autopay-terms-conditions.component.css'],
})
export class AutopayTermsConditionsComponent implements OnInit{
  @Input() type = "";
  @Output() showTermsConditions: EventEmitter<boolean> = new EventEmitter();
  isAcmic: boolean;
  constructor(
      private acmicService: AcmicService,
    ) {}
  
    ngOnInit() {
      this.isAcmic = this.acmicService.isACMIC();
    }

    onClose(){
      this.showTermsConditions.emit(false);
    }
}
